module.exports = __webpack_public_path__ + "static/media/softwareDevelopment.1e467fbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/softwareDevelopment.jpg
// module id = 799
// module chunks = 5